export default __webpack_public_path__ + "static/media/applelogo.7ff6dd84.png";